// extracted by mini-css-extract-plugin
export default {"hero__title":"Hero_hero__title__FTRYz","hero__text":"Hero_hero__text__RargL","button":"Hero_button__5i4MT","hero__button2":"Hero_hero__button2__hBI4D"};